.searchField {
  max-width: 20rem;
}

.searchBar {
  flex-wrap: wrap;
  justify-content: flex-end;

  :global(.input-group) {
    min-width: 17rem;
    flex: 1;
  }

  :global(.button) {
    white-space: nowrap;
  }
}
